export default "__VITE_ASSET__CRsUFBYb__"